import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Auth.css';

const TermsPolicy = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Get return URL from session storage or default to homepage
  const returnUrl = sessionStorage.getItem('returnToAfterTerms') || '/';
  
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Container className="terms-policy-container py-5">
      <div className="terms-policy-content bg-white p-4 rounded shadow">
        <h1 className="text-center mb-4">{t('termsPolicy.title')}</h1>
        
        <section className="mb-4">
          <h2>{t('termsPolicy.introTitle')}</h2>
          <p>{t('termsPolicy.introText')}</p>
        </section>

        <section className="mb-4">
          <h2>{t('termsPolicy.dataCollectionTitle')}</h2>
          <p>{t('termsPolicy.dataCollectionText')}</p>
          <ul>
            <li>{t('termsPolicy.dataName')}</li>
            <li>{t('termsPolicy.dataEmail')}</li>
            <li>{t('termsPolicy.dataPhone')}</li>
            <li>{t('termsPolicy.dataPhotos')}</li>
            <li>{t('termsPolicy.dataWishes')}</li>
            <li>{t('termsPolicy.dataLikes')}</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>{t('termsPolicy.dataSharingTitle')}</h2>
          <p>{t('termsPolicy.dataSharingText')}</p>
        </section>

        <section className="mb-4">
          <h2>{t('termsPolicy.dataRetentionTitle')}</h2>
          <p>{t('termsPolicy.dataRetentionText')}</p>
        </section>
        
        <section className="mb-4">
          <h2>{t('termsPolicy.dataDeleteTitle')}</h2>
          <p>{t('termsPolicy.dataDeleteText')}</p>
        </section>

        <section className="mb-4">
          <h2>{t('termsPolicy.contentGuidelinesTitle')}</h2>
          <p>{t('termsPolicy.contentGuidelinesText')}</p>
          <ul>
            <li>{t('termsPolicy.contentRespectful')}</li>
            <li>{t('termsPolicy.contentAppropriate')}</li>
            <li>{t('termsPolicy.contentLegal')}</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>{t('termsPolicy.contactTitle')}</h2>
          <p>{t('termsPolicy.contactText')}</p>
        </section>

        <div className="d-flex justify-content-between mt-5">
          <Button variant="secondary" onClick={handleBack}>
            {t('termsPolicy.backButton')}
          </Button>
          <Link to={returnUrl} className="btn btn-primary">
            {t('termsPolicy.acceptButton')}
          </Link>
        </div>
      </div>
    </Container>
  );
};

export default TermsPolicy;